import {
  CreateContextProvider,
  Form,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import DailyPrizePoolForm from './DailyPrizePoolForm';
import { createDailyPrizePoolConfig, PoolType } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const CreateDailyPrizePoolConfig = ({
  poolType,
  onClose,
}: {
  poolType: PoolType;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.redpacket,
    mutationOptions: {
      onSuccess: () => {
        notify('Created successfully', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'Creation failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        await createDailyPrizePoolConfig({
          poolType,
          dailyBudget: String(data.dailyBudget),
          resetHourUTC: Number(data.resetHourUTC ?? 0),
          isActive: data.isActive ?? true,
          description: data.description,
        });
        notify('Created successfully', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'Creation failed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>
          Create {poolType === PoolType.SHARED ? 'Shared' : 'Critical Hit'} Pool Configuration
        </DialogTitle>
        <DialogContent>
          <DailyPrizePoolForm poolType={poolType} isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="create">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateDailyPrizePoolConfig;

